import { render, staticRenderFns } from "./Clubs.vue?vue&type=template&id=b265d6dc&scoped=true&"
import script from "./Clubs.vue?vue&type=script&lang=js&"
export * from "./Clubs.vue?vue&type=script&lang=js&"
import style0 from "./Clubs.vue?vue&type=style&index=0&id=b265d6dc&prod&scoped=true&lang=css&"
import style1 from "./Clubs.vue?vue&type=style&index=1&id=b265d6dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b265d6dc",
  null
  
)

export default component.exports